import {
  Button,
  Divider,
  Drawer,
  Row,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";

import React, { useEffect } from "react";
import "./ChatBoxModal.css";
import { ReactComponent as ArrowSquare } from "../../../assests/arrow-square-out.svg";
import ChatAndActivitySegment from "../../common/chat-activity-tab/ChatAndActivityTabs";
import ChatTerms from "../../common/chat-terms/ChatTerms";
import { useDispatch, useSelector } from "react-redux";

import {
  setAllowChat,
  setIsChatModal,
  setIsProductChat,
} from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";
import { capitalizeFirst } from "../../common/utils/Utils";
import CampaignChatList from "../../common/seller-chat-components/CampaignsChatList";
import { CloseOutlined } from "@ant-design/icons";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;
const ChatBoxModal = ({ canvasWidth }) => {
  const {
    isChatModal,
    isProductInfo,
    campaignInfoForChat,
    allowChat,
    isProductChat,
  } = useSelector((state) => state.chatCommunicationHandleSlice);
  const { userType, chatsMonitered, professionalGuidelines } = useSelector(
    (state) => state.userprofile
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sellerInfo = (
    <div>
      <Text className="chat-user-info">
        Owner: {capitalizeFirst(isProductInfo?.client_name)}
      </Text>
      <br />
      <Text className="chat-user-info">
        Product Name: {isProductInfo?.title}
      </Text>
      <br />
      <Text className="chat-user-info">
        Campaign Name: {capitalizeFirst(campaignInfoForChat?.name)}
      </Text>
    </div>
  );

  const handleProductDetails = () => {
    const encodedId = btoa(isProductInfo?.product_id);
    const url = `/buyer/productsdetails?_id=${encodedId}`;

    // Open in new tab
    window.open(url, "_blank", "noopener,noreferrer");

    // Keep breadcrumb logic (current tab)
    dispatch(
      addBreadcrumb({
        title: isProductInfo?.title,
        path: url,
      })
    );
  };

  useEffect(() => {
    if (chatsMonitered === true && professionalGuidelines === true) {
      dispatch(setAllowChat(true));
    } else {
      dispatch(setAllowChat(false));
    }
  }, [chatsMonitered, professionalGuidelines, dispatch]);
  return (
    <Drawer
      placement="right"
      width={canvasWidth}
      open={isChatModal}
      onClose={() => dispatch(setIsChatModal(false))}
      footer={null}
      closable={false}
      title={
        <div className="chat-component-drawer">
          {isProductChat ? (
            <>
              {" "}
              <Button
                className="product-chat-back-btn"
                onClick={() => {
                  dispatch(setIsProductChat(false));
                }}
              >
                <Text className="products-chat-back-btn-txt">Back</Text>
              </Button>
            </>
          ) : (
            <>
              <div>
                {userType !== "owner" ? (
                  <>
                    {/* <Text className="component-header-text">
                      Transit Wrap - Bostons
                    </Text> */}
                  </>
                ) : (
                  <>
                    <div>
                      <Text className="component-header-text">Messages</Text>
                    </div>
                    <div>
                      <Text className="component-header-sub-text">
                        Conversations with buyers about your billboards
                      </Text>
                    </div>
                  </>
                )}
              </div>
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={() => dispatch(setIsChatModal(false))}
              />
            </>
          )}
        </div>
      }
    >
      <div className="chat-section-div">
        {userType !== "owner" ? (
          <>
            <div> {sellerInfo}</div>
            <Row justify="center">
              <Button
                className="view-product-btn-chatbox-modal"
                onClick={handleProductDetails}
              >
                <ArrowSquare />
                <Text className="view-product-btn-chatbox-Text">
                  View Product Details
                </Text>
              </Button>
            </Row>
            <Divider />
            <div>
              {allowChat ? (
                <ChatAndActivitySegment
                  senderName={capitalizeFirst(campaignInfoForChat?.name)}
                />
              ) : (
                <ChatTerms />
              )}
            </div>
          </>
        ) : (
          <div>{allowChat ? <CampaignChatList /> : <ChatTerms />}</div>
        )}
      </div>
    </Drawer>
  );
};

export { ChatBoxModal };
